import { Extension } from "@codemirror/state";
import { EditorView } from "@codemirror/view";

export function createAutofillOnEmpty(
  autofillOnEmpty: string | null
): Extension {
  return EditorView.domEventHandlers({
    focus: (_, view) => {
      if (!autofillOnEmpty) return;
      const currentContent = view.state.doc.toString().trim();
      if (currentContent !== "") return;

      const cursorMarker = "PLACECURSORHERE";
      const contentToInsert = autofillOnEmpty.replace(cursorMarker, "");
      const markerIndex = autofillOnEmpty.indexOf(cursorMarker);

      view.dispatch({
        changes: {
          from: 0,
          to: view.state.doc.length,
          insert: contentToInsert
        }
      });

      setTimeout(() => {
        view.dispatch({
          selection: {
            anchor: markerIndex,
            head: markerIndex
          },
          scrollIntoView: true
        });
      }, 0);
    }
  });
}
